export default import.meta.ROLLDOWN_FILE_URL_b$zJFQBw26_tBLE5EuBOig